import React, { useEffect } from 'react';

export default function KuulaProject(props) {

	useEffect(() => {
		// console.log('window', window)
	}, []);

	return (
		<div>
			<iframe className="ku-embed" 
				title="Coheed-And-Cambria" 
				style={{ border: 'none' }} allowFullScreen allow="xr-spatial-tracking; gyroscope; accelerometer" scrolling="no" 
				src="https://tours.mindpower.dev/share/collection/7Zstz?logo=-1&info=0&fs=0&vr=1&thumbs=-1&keys=0"></iframe>
		</div>
	)

}

